import {
  ArrowDownIcon,
  ArrowUpIcon,
  Dropdown,
  DropdownOption,
  FontSizeEnum,
  IconSizeEnum,
  FontColorEnum,
  FontWeightEnum,
  Typography,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type SortDirectionDropdownProps = {
  value: string;
  onChange: (direction: string) => void;
  className?: string;
  optionsClassName?: string;
};

export function SortDirectionDropdown({
  value,
  onChange,
  className,
  optionsClassName,
}: SortDirectionDropdownProps) {
  const { t } = useTranslation();
  const label = value === 'asc' ? t('Ascendente') : t('Descendente');

  const options: DropdownOption[] = [
    {
      label: t('Descendente'),
      value: 'desc',
      icon: <ArrowDownIcon size={IconSizeEnum.XS} />,
      className: '!justify-start',
    },
    {
      label: t('Ascendente'),
      value: 'asc',
      icon: <ArrowUpIcon size={IconSizeEnum.XS} />,
      className: '!justify-start',
    },
  ];

  return (
    <Dropdown
      className={clsx('min-w-[130px]', className)}
      onChange={onChange}
      textSize={FontSizeEnum.Md}
      options={options}
      optionsClassName={clsx(optionsClassName)}
      buttonClassName="bg-transparent hover:bg-transparent text-text-medium-20 hover:text-accent-active-primary-40"
      value={value}
    >
      <div className="flex flex-row items-center gap-1">
        {value === 'asc' ? (
          <ArrowUpIcon size={IconSizeEnum.XS} />
        ) : (
          <ArrowDownIcon size={IconSizeEnum.XS} />
        )}
        <Typography
          fontSize={FontSizeEnum.Sm}
          weight={FontWeightEnum.Regular}
          color={FontColorEnum.Dark10}
        >
          {label}
        </Typography>
      </div>
    </Dropdown>
  );
}
